module.exports = __webpack_public_path__ + "img/newType_1.6440af72.png";